import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=b67b3514&scoped=true&"
import script from "./UserEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67b3514",
  null
  
)

export default component.exports